import { render, staticRenderFns } from "./CompanyAddDocumentModal.vue?vue&type=template&id=5aec6519&scoped=true&"
import script from "./CompanyAddDocumentModal.vue?vue&type=script&lang=js&"
export * from "./CompanyAddDocumentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aec6519",
  null
  
)

export default component.exports